
import { Prop, Watch, Component, Vue } from "vue-property-decorator";
import debounce from "debounce";
import { TranslateResult } from "vue-i18n";

@Component({})
export default class MylobyAutocomplete extends Vue  {

  get filteredItems(): any[] {
    return this.customFilterFn
      ? this.items.filter(this.customFilterFn)
      : this.items;
  }

  @Prop({ default: null })
  public companyId: number;

  @Prop({ default: null })
  public storePathFn: string;

  @Prop({ default: null })
  public storeQueryPayload: any;

  @Prop({ default: null })
  public displayLineFn: (item: any) => string;

  @Prop({
    default: () => (item: any) => "",
  })
  public displaySubLineFn!: (item: any) => string;

  @Prop({ default: null })
  public customFilterFn: (item: any) => boolean;

  @Prop({ default: null })
  public initItem: any;

  @Prop({ default: "rows" })
  public returnKey: string;

  @Prop({ default: false })
  public disabled: boolean;

  @Prop({ default: true })
  public flat: boolean;

  @Watch("search", { immediate: false })
  public handlerSearch = debounce(this.getFirstItems, 500);

  @Prop()
  private label: TranslateResult;

  @Prop({ default: () => "id" })
  private itemValue: (item: any) => any;

  @Prop({ default: null })
  private value!: string;

  private items: any[] = [];
  private selected: any = null;
  private page: number = 1;
  private itemsPerPage: number = 10;
  private totalItems: number = null;
  private search: string = null;
  private loading: boolean = false;

  @Watch("companyId")
  public handlerCompanyId(newVal, oldVal) {
    if (newVal && newVal !== oldVal) {
      this.getFirstItems();
    }
  }

  @Watch("value", { immediate: true })
  public handlerValue(newVal, oldVal) {
    if (newVal !== oldVal) {
      this.selected = this.value;
    }
  }

  private async mounted(): Promise<void> {
    await this.getFirstItems();
  }

  private clear(): void {
    this.selected = null;
    this.setModel();
  }

  private setModel() {
    this.$emit("input", this.selected);
  }

  private async getFirstItems(): Promise<void> {
    this.page = 1;
    this.items = [];
    await this.getItems();
    if (this.initItem && !this.search) {
      this.items.unshift(this.initItem);
    }
  }

  private async getNextItems(): Promise<any> {
    this.page++;
    await this.getItems();
  }

  private async getItems(): Promise<void> {
    this.loading = true;
    return this.$store.dispatch(this.storePathFn, {
      companyId: this.companyId,
      search: this.search,
      page: this.page,
      itemsPerPage: this.itemsPerPage,
      ...this.storeQueryPayload,
    })
      .then((res) => {
        this.items = [...this.items, ...(res?.[this.returnKey] || [])];
        this.totalItems = res?.count || 0;
      })
      .catch((error) => {
        this.$emit("error", error);
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
